import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Title', defaultMessage: 'Title' },
  imageList: { id: 'Image list', defaultMessage: 'Image list' },
  hideImagesTitles: {
    id: 'Hide images titles',
    defaultMessage: 'Hide images titles',
  },
  hideImagesDates: {
    id: 'Hide images dates',
    defaultMessage: 'Hide images dates',
  },
});

export const imageListSchema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.imageList),
        fields: ['title', 'hideTitles', 'hideDates'],
      },
    ],
    properties: {
      title: { title: intl.formatMessage(messages.title) },
      hideTitles: {
        title: intl.formatMessage(messages.hideImagesTitles),
        required: false,
        default: false,
        type: 'boolean',
      },
      hideDates: {
        title: intl.formatMessage(messages.hideImagesDates),
        required: false,
        default: false,
        type: 'boolean',
      },
    },
    required: ['title'],
  };
};
